import Radio from '@mui/material/Radio'

import { type JSX } from 'react'
import { TextBody } from '../../../data-display/typography/Typography'
import type { SelectableListItemProps } from '../../lists/types'
import {
  StyledInputListItem,
  StyledListItemErrorMessage,
  StyledListItemText,
} from '../ListItem.styles'
import { AdditionalText } from '../additional-text/AdditionalText'

export const RadioListItem = <T,>({
  onClick,
  itemId,
  selected,
  label,
  disabled = false,
  additionalText,
  additionalTextColor,
  role = 'radio',
  variant,
  'data-testid': dataTestId,
  ariaLabel,
  required,
  errorMessage,
  customIcon,
}: SelectableListItemProps<T>): JSX.Element => {
  const onClickCallback = () => onClick(itemId)

  const getA11yLabel = () => {
    if (ariaLabel) {
      return ariaLabel
    }
    return typeof label === 'string' ? label : undefined
  }

  const showError = required && !selected

  return (
    <StyledInputListItem
      className={variant}
      disabled={disabled}
      selected={selected}
      onClick={onClickCallback}
      alignItems="center"
      aria-label={getA11yLabel()}
      role={role}
      variant={variant}
      error={showError}
      aria-checked={customIcon ? selected : undefined}
    >
      {customIcon || (
        <Radio
          disableRipple
          checked={selected}
          disabled={disabled}
          slotProps={{
            input: {
              'data-testid': dataTestId,
            } as React.InputHTMLAttributes<HTMLInputElement>,
          }}
        />
      )}
      <StyledListItemText>
        <TextBody>{label}</TextBody>
        <AdditionalText
          additionalText={additionalText}
          color={additionalTextColor}
        />
        {showError && errorMessage && (
          <StyledListItemErrorMessage>
            {errorMessage}
          </StyledListItemErrorMessage>
        )}
      </StyledListItemText>
    </StyledInputListItem>
  )
}
